G.BoosterVertical = function (cellX, cellY, nr) {
  this.board = G.lvl.board;
  this.am = this.board.actionManager;
  this.cellX = cellX;
  this.cellY = cellY;

  Phaser.Image.call(
    this,
    game,
    this.board.cellXToPxIn(cellX),
    this.board.cellYToPxIn(-0.5),
  );

  this.anchor.setTo(0.5);

  this.boosterNr = nr;

  this.oldCellY = -1;

  this.orgY = this.y;
  this.targetY = this.board.cellYToPxIn(this.board.boardData.height) + G.l(30);

  G.changeTexture(this, G.OMTsettings.global.jungleMatch 
    ? `ui_booster_${nr}_no_bg` : `ui_booster_${nr}`);
  this.alpha = 0;
  this.scale.setTo(2);

  game.add.tween(this.scale).to({ x: 1, y: 1 }, 1000, Phaser.Easing.Sinusoidal.Out, true);
  game.add.tween(this).to({ alpha: 1 }, 1000, Phaser.Easing.Sinusoidal.Out, true).onComplete.add(function () {
    this.active = true;
  }, this);
};

G.BoosterVertical.prototype = Object.create(Phaser.Image.prototype);

G.BoosterVertical.prototype.getMatchCandy = function (nr) {
  if (nr === 2) return { cellX: this.cellX, cellY: this.cellY, exe: [['specific', [0, 0]]] };

  if (nr === 3) return { cellX: this.board.boardData.width - 1, cellY: this.cellY, exe: [['loop', { x: -1, y: 0 }], ['loop', { x: 1, y: 0 }]] };

  if (nr === 4) return { cellX: this.cellX, cellY: this.board.boardData.height - 1, exe: [['loop', { x: 0, y: -1 }], ['loop', { x: 0, y: 1 }]] };
};

G.BoosterVertical.prototype.update = function () {
  if (!this.active) return;

  this.y += G.l(10);

  const cellY = this.board.pxInToCellY(this.y);

  if (cellY !== this.oldCellY) {
    this.oldCellY = cellY;
    this.board.useBoosterOnCell(this.cellX, cellY - 1);
  }

  if (this.y >= this.targetY && this.board.duringAnimation === 0) {
    this.active = false;
    if (this.board.checkSpecialMatchList.length === 0) {
      this.am.newAction('processFall');
    } else {
      this.am.newAction('processMatch');
    }

    G.sb('onBoosterActionFinished').dispatch();
    this.am.removeAction();
    this.destroy();
  }
};
